export default "__VITE_ASSET__369ba025__"